// SportsGuru247 app shell.
// Routing lives in `components/AppRoutes.jsx`. This file only wires layout + global init.
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";

import Navigation from "./components/layout/Navigation";
import OperatorStrip from "./components/layout/OperatorStrip";
import PageTracker from "./components/layout/PageTracker";
import BannerStack from "./components/layout/BannerStack";
import AppRoutes from "./components/AppRoutes";

import { StickyFooterBanner } from "./components/banners";
import ResponsibleGamblingFooter from "./components/ResponsibleGamblingFooter";

import { initClickTracking } from "./utils/analytics";
import {
  initUnifiedClickTracking,
  initEngagementTracking,
} from "./utils/unifiedTracking";
import { initTracking } from "./utils/fbTracking";
import { captureUtmsFromUrl } from "./utils/utm";

// Run once at module load
initTracking();
captureUtmsFromUrl();

function App() {
  useEffect(() => {
    // Push tracking init off the critical path — fire it during the browser's
    // idle window so LCP/FCP aren't blocked by analytics work.
    const init = () => {
      initClickTracking();
      initUnifiedClickTracking();
      initEngagementTracking();
      // eslint-disable-next-line no-console
      console.log("[SportsGuru247] All tracking initialized");
    };
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      window.requestIdleCallback(init, { timeout: 3000 });
    } else {
      setTimeout(init, 1500);
    }
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-slate-950">
          <PageTracker />
          <Navigation />
          <OperatorStrip />
          <BannerStack />
          <AppRoutes />
          <ResponsibleGamblingFooter />
          <StickyFooterBanner />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
